import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { SampleType } from "./DialogSampleTable";
import Waveform from "../../../component/common/waveSurfer/WaveForm.js";
import api from "../../../../API";
import SampleRejectRsnDialog from "./SampleRejectRsnDialog";
import PhotoIcon from '@mui/icons-material/Photo';
import DescriptionIcon from '@mui/icons-material/Description';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useSelector } from "react-redux";

interface userDetailProps {
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  rowDetail: SampleType | null;
  setRowDetail: React.Dispatch<React.SetStateAction<SampleType>>;
  getMemberList: any;
}

const initailData: SampleType = {
  idx: -1,
  email: "",
  name: "",
  user_id: "",
  file_audio: "",
  file_srt: "",
  file_photo: "",
  state: "",
  upload_date: "",
  ins_date: "",
  reject_rsn: "",
  sampleFiles: [],
  documentFiles: [],
};

const SampleDetailDialog = (props: userDetailProps) => {
  // console.log("props", props);
  const [data, setData] = useState<SampleType>(initailData);

  const [jumin, setJumin] = useState("");

  const [open, setOpen] = useState<boolean>(true);

  const [auths, setAuths] = useState([]);
  const [selectedAuth, setSelectedAuth] = useState('');

  const [rejectPageOpen , setRejectPageOpen] = useState<boolean>(false);

  const [dialogSize , setDialogSize] = useState(false)

  const [sampleFileName, setSampleFileName] = useState("")

  const [photoUrl , setPhotoUrl] = useState("")

  const [srt , setSrt] = useState("")

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  

  const getAuths = async () => {
    var result = await api.get("/getAuths");

    setAuths(result.data.data);
    // console.log('result.data.data',result.data.data)
  };

  const getSampleFileInfo = async (idx:number, file_type:string) => {

    if(file_type === "photo"){
      //사희철
      setPhotoUrl("http://121.135.229.125/api/sampleFileInfo?idx="+idx+"&file_type="+file_type)
    }else{
      setPhotoUrl("")
      await api.get("/sampleFileInfo?idx="+idx+"&file_type="+file_type)
      .then((res:any) => {console.log('sampleFileInfo res', setSrt(res.data)); })
      .catch((e:any) => console.log('sampleFileInfo error' , e));
    }

  };

  const getDocumentFileInfo = async (idx:number, file_type:string, file_name:string) => {

    if(file_type === "photo"){
      setDialogSize(true);
      setPhotoUrl(window.location.origin.replace(':3000',':9680')+"/sampleFileInfo?document=true&idx="+idx+"&file_type="+file_type)
    }else{
      // setPhotoUrl("")
      console.log('pdf 클릭')
      setDialogSize(false)
      await api.get("/sampleFileInfo?document=true&idx="+idx+"&file_type="+file_type,{ responseType: 'blob' })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file_name);
        document.body.appendChild(link);
        link.click();
      })
      .catch((e:any) => console.log('sampleFileInfo error' , e));
    }

  };

  const sampleConfirm = async () => {

    // console.log(data.email, selectedAuth , data.new_file_name)

    // console.log('selectedAuth' , selectedAuth)

    // 정호영 수석님 요청 롤 선택아닌 자동반영 230721 금요일 회의
    // if(!selectedAuth){
    //   alert("사용자에게 부여할 권한을 선택하세요.")
    //   return ;
    // }
    

  
    // var result = await api.post("/sampleConfirm",{"email":data.email,"role":selectedAuth,"new_file_name":data.new_file_name});

    // console.log('sampleConfirm result',result)
    await api.post("/sampleConfirm",{"worker":data.email,"role":"NKI","idx":data.idx,"type":"dialog","email":email})
    .then((res:any) => {console.log('sampleConfirm result',res); props.getMemberList(); props.setDialogOpen(false); alert("샘플 검수가 완료되었습니다. 권한: " + selectedAuth);})
    .catch((e) => {if(e.response.status == 400) alert("서버오류입니다. ")})

  }

  const documentConfirm = async () => {

    // console.log(data.email, selectedAuth , data.new_file_name)

    // console.log('selectedAuth' , selectedAuth)

    if(!selectedAuth){
      alert("사용자에게 부여할 권한을 선택하세요.")
      return ;
    }

    console.log('documentConfirm ' , "email",data.email,"role",selectedAuth,"idx",data.idx)

    // return;
    // var result = await api.post("/sampleConfirm",{"email":data.email,"role":selectedAuth,"new_file_name":data.new_file_name});

    // console.log('sampleConfirm result',result)
    await api.post("/documentConfirm",{"email":data.email,"role":selectedAuth,"idx":data.idx})
    .then((res:any) => {console.log('sampleConfirm result',res); props.getMemberList(); props.setDialogOpen(false); alert("문서 검수가 완료되었습니다. 권한: " + selectedAuth)})
    .catch((e) => {if(e.response.status == 400) alert("서버오류입니다. ")})

  }

  const getUserInfo = async (worker:string) => {

    await api.get("/userInfoByAdmin",{params:{email:email,worker:worker}})
    .then((res:any) => {console.log('관리자 유저 검색',res , setJumin(res.data.jumin))})
    .catch((e) => {if(e.response.status == 400) alert("서버오류입니다. ")})

  }

  const stopWaveform = () =>{
    props.setDialogOpen(false); 
    props.setRowDetail(initailData);
  }

  const setRole = (v: any) => {
    setSelectedAuth(v);
  }

  const sampleReject = () => {
    setRejectPageOpen(false);
    setOpen(false);
    props.setDialogOpen(false); 
    props.getMemberList();
  }

  useEffect(() => {
    getAuths();
    // console.log("sampleDetailDialog");
    if (props.rowDetail != null){
      setData(props.rowDetail);
      // if(props.rowDetail.state)
      console.log('props.rowDetail.state',props.rowDetail.state)
      if(props.rowDetail.state === '문서제출'){
        getUserInfo(props.rowDetail.email)
      }
    }
  }, [props.rowDetail]);

  return (
    <Box>
      <Dialog maxWidth={dialogSize ? "xl" : "md"} open={true} fullWidth={true}>
        <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
          <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>Sample 확인</Box>
          <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
        </DialogTitle>
        <DialogContent dividers>
          <Box display="flex" justifyContent="center">
            <Box>

              {/* wavform */}
              <Box>
                {data.idx !== -1 ? 
                <React.Fragment>
                  <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>Audio 플레이</Box>
                  <Waveform url={"http://121.135.229.125/api/sampleFileInfo?file_type=audio&idx="+data.idx} open={open} stopWaveform={stopWaveform} />
                </React.Fragment>
                :""}
              </Box>
              {/* wavform */}

            <Box>
              {data.idx !== -1 ? 
              <React.Fragment>
              <Box sx={{marginLeft:"2px",marginTop:"16px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>관련자료</Box>
              <Box sx={{width: "95%", border: "3px solid #3e36a5", borderRadius: "3px", margin: "12px", padding: "8px", display:"block" , justifyContent:"center"}}>
                {data.sampleFiles ? 
                <React.Fragment>
                {data.sampleFiles.map((sampleFile:any) => 
                  {
                    if(sampleFile.file_type !== "audio"){
                      return (
                        <Box key={sampleFile.idx} display="flex" sx={{marginBottom:"4px", marginLeft:"32px"}}>
                          <Box sx={{marginRight:"40px"}}>{sampleFile.file_type === "photo" ? <PhotoIcon/> : <DescriptionIcon/>}</Box>
                          <Box sx={{width:"390px",fontWeight:700}}>{sampleFile.origin_file_name}</Box>
                          <Box sx={{margin:"auto"}}>
                            <Button sx={{backgroundColor:"#ff9800", fontWeight:700}} size="small" variant="contained" onClick={()=>{getSampleFileInfo(sampleFile.idx,sampleFile.file_type); setDialogSize(true); setSampleFileName(sampleFile.origin_file_name)}}>
                              확인
                            </Button>
                          </Box>
                        </Box>
                      )
                    }
                  }
                )}
                </React.Fragment>
                :""}
              </Box>
              </React.Fragment>
              :""}
            </Box>

            <Box display="flex">
              <Box sx={{width:"100%", margin:"8px"}}>
                <Box m={1} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>이메일</Box>
                  <TextField
                    id="email"
                    value={data.email}
                    type="email"
                    variant="standard"
                    sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  <Box sx={{fontWeight:700, marginBottom:"4px", width:"70px"}}>이름</Box>
                <TextField
                  id="name"
                  value={data.name}
                  variant="standard"
                  sx={{marginLeft:"8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                  onChange={(e: any) =>
                    setData((preData) => ({ ...preData, name: e.target.value }))
                  }
                  InputProps={{
                    readOnly: true,
                  }}
                />
                </Box>
                <Box m={1} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>녹음파일</Box>
                  <TextField
                    id="origin_file_name"
                    value={data.file_audio}
                    // label="원본파일명"
                    variant="standard"
                    sx={{width:"80%", marginLeft:"8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                    onChange={(e: any) =>
                      setData((preData) => ({ ...preData, origin_file_name: e.target.value }))
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Box>
                <Box m={1} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>자막파일</Box>
                  <TextField
                    id="new_file_name"
                    value={data.file_srt}
                    // label="서버파일명"
                    variant="standard"
                    sx={{width:"80%", marginLeft:"8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Box>
                <Box m={1} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>사진파일</Box>
                  <TextField
                    id="file_dir"
                    value={data.file_photo}
                    // label="파일경로"
                    type="tel"
                    variant="standard"
                    sx={{width:"80%", marginLeft:"8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                    onChange={(e: any) =>
                      setData((preData) => ({ ...preData, file_dir: e.target.value }))
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Box>
                <Box m={1} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>업로드시간</Box>
                  <TextField
                    id="ins_date"
                    value={data.ins_date}
                    // label="업로드시간"
                    variant="standard"
                    sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  <Box sx={{fontWeight:700, marginBottom:"4px", width:"70px"}}>처리상태</Box>
                  <TextField
                    id="state"
                    value={data.state}
                    variant="standard"
                    sx={{marginLeft:"8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Box>
                {/* <Box m={1} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>할당권한 {<b style={{color:"red"}}>(필수)</b>}</Box>
                  <Box sx={{ minWidth: 120 }}>
                    <FormControl sx={{width:"200px"}}>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedAuth}
                        label="권한"
                        sx={{height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        onChange={(e)=> {data.user_id == '' ? setRole(e.target.value) : null}}
                      >
                        {auths.length !== 0 ? (
                          auths.map((auth: any, index:number) => {
                            // console.log('권한' , auth,data.user_id)
                            // if(!selectedAuth && (data.user_id.split('_')[0] == auth.code)) {
                            //   setSelectedAuth(auth.code)
                            // }
                            console.log('권한' , data.user_id)
                            if(data.user_id != '' && selectedAuth == '') setSelectedAuth('NKI')
                              
                            // const labelId = `checkbox-list-secondary-label-${auth.code_nm}`;
                            return (
                              // <MenuItem selected={data.user_id.split('_')[0] == auth.code ? true : false} key={auth.code} dense value={auth.code}>{auth.code_nm}</MenuItem>
                              <MenuItem key={auth.code} dense value={auth.code}>{auth.code_nm}</MenuItem>
                            );
                          })
                        ) : (
                          []
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                </Box> */}
              </Box>
            </Box>
            {rejectPageOpen ? <SampleRejectRsnDialog email={data.email} idx={data.idx} getMemberList={props.getMemberList} setRejectPageOpen={setRejectPageOpen} setOpen={setOpen} /> : <></>}
            {/* </form> */}
            </Box>
            {dialogSize && photoUrl != "" ?
              <Box>
                  <Box display="flex">
                    <Box sx={{marginLeft:"18px", marginRight:"auto", marginBottom:"12px", fontWeight:700, fontSize: "16px"}}>이미지 : {sampleFileName}</Box>
                    {/* <Box><Button sx={{margin:"auto"}} variant="contained" onClick={()=> setDialogSize(false)}>닫기</Button></Box> */}
                    <Box><HighlightOffIcon sx={{cursor:"pointer", marginRight:"16px"}} onClick={()=> setDialogSize(false)} /></Box>
                  </Box>
                  <Paper sx={{padding:"4px", border:"3px solid #3e36a5", width:"654px" , height:"654px", overflow: "hidden", position: "relative"}}>
                    <img src={photoUrl} style={{width: "100%", height: "auto", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}} />
                    {/* <Button variant="contained" onClick={()=> setDialogSize(false)}>닫기</Button> */}
                  </Paper>
              </Box>
                :
                (
                  dialogSize && photoUrl == "" ? 
                  <Box>
                    <Box display="flex">
                      <Box sx={{marginLeft:"18px", marginRight:"auto", marginBottom:"12px", fontWeight:700, fontSize: "16px"}}>SRT : {sampleFileName}</Box>
                      {/* <Box><Button sx={{margin:"auto"}} variant="contained" onClick={()=> setDialogSize(false)}>닫기</Button></Box> */}
                      <Box><HighlightOffIcon sx={{cursor:"pointer", marginRight:"16px"}} onClick={()=> setDialogSize(false)} /></Box>
                    </Box>
                    <Paper sx={{padding:"4px", border:"3px solid #3e36a5"}}>
                      <textarea readOnly defaultValue={srt} style={{width:"654px" , height:"654px"}}  />
                    </Paper>
                  </Box>
                :
                ""
                )
            }
            
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
            onClick={() => {
              setOpen(false);
            }}
          >
            취소
          </Button>
          {data.state === "검사완료"?
          ""
          :
          (data.state === "문서제출" ? 
          (<React.Fragment>
            <Button variant="contained" color="error" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                // sampleReject();
                setRejectPageOpen(true);
              }}
            >
              문서 검수반려
            </Button>
            <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                documentConfirm();
              }}
            >
              문서 검사완료
            </Button>
          </React.Fragment>)
          :
          (<React.Fragment>
          <Button variant="contained" color="error" sx={{fontWeight:700, margin:"8px 16px"}}
            onClick={() => {
              // sampleReject();
              setRejectPageOpen(true);
            }}
          >
            샘플 검수반려
          </Button>
          <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
            onClick={() => {
              sampleConfirm();
            }}
          >
            샘플 검사완료
          </Button>
          </React.Fragment>)
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SampleDetailDialog;
